import { buildPlaceUrls } from '@aviv_price-pages/brand';
import { useNavigate } from '@aviv-unified-frontend/runtime/router';
import { appendEphemeralParam } from '@/helpers/ephemeral/ephemeral';
import { usePageLayoutContext } from '@/hooks/usePageLayoutContext/usePageLayoutContext';
import { Logger } from '@/logger';
/**
 * Hook to navigate to a place page
 *
 * @param brandNameAbbreviation - Abbreviation of the brand name used to build URL
 * @param getDataMAttributeFunction - A function to get Medium Attributes
 * @returns Object with a `navigate` function to navigate to the given place
 */
export function usePlaceNavigation(brandNameAbbreviation, getDataMAttributeFunction) {
    const navigate = useNavigate();
    const { pricePageProps: { pricePageContext }, } = usePageLayoutContext();
    const navigateToPlace = async (place) => {
        try {
            let placeUrl = (await buildPlaceUrls(brandNameAbbreviation, [place]))[0];
            if (getDataMAttributeFunction) {
                const dataMAttribute = getDataMAttributeFunction(pricePageContext.place.type, place.type);
                placeUrl += `?m=${dataMAttribute}`;
            }
            navigate(appendEphemeralParam(placeUrl));
        }
        catch (error) {
            Logger.error(error);
        }
    };
    return { navigateToPlace };
}
